module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-tested-solutions.de@1x-33c3c01b84a8c6f2328c5e00d2af0f2a.png";